<template>
  <div class="hidden lg:flex  max-w-[80px] w-[80px] lg:flex-col lg:fixed lg:inset-y-0">
    <!-- Sidebar component, swap this element with another sidebar if you like -->
    <div class="flex flex-col h-full     bg-gray-200 pt-2 pb-0 overflow-y-auto items-center">

      <nav class="mt-12 mb-0 ml-0 pt-6 cursor-pointer pl-0 font-medium    px-0 space-y-6 ">
        <!-- item-->

        

  
          


        

  <!-- Botón Año Borrador con submenú -->
          <div v-if="this.$store.state.auth.userLogin.año ">
            <button @click="toggleSubMenu()"
              class="flex px-4 py-3 text-white rounded-lg    bg-violet-600 hover:bg-violet-900 transition relative">
              <span class="text-lg font-semibold tracking-wide text-white">
                {{ this.$store.state.auth.userLogin.año  }}
              </span>
              <!-- Indicador de flecha -->
              <span class="absolute -right-0 mt-1  text-[15px] text-white">
                {{ subMenuAbierto ? '◀' : '▶' }}
              </span>
            </button>
            <span class="text-xs font-semibold tracking-wide text-green-700"></span>
          </div>
        

       
  <!-- Botón Año Borrador con submenú -->
          <div v-if="this.$store.state.auth.userLogin.año_borrador && this.$store.state.auth.userLogin.is_admin">
            <button @click="toggleSubMenuBorr()"
              class="flex px-4 py-3 text-white rounded-lg bg-green-700 hover:bg-green-900 transition relative">
              <span class="text-lg font-semibold tracking-wide text-white">
                {{ this.$store.state.auth.userLogin.año_borrador }}
              </span>
              <!-- Indicador de flecha -->
              <span class="absolute -right-0  mt-1  text-[15px] text-white">
                {{ subMenuBorrAbierto ? '◀' : '▶' }}
              </span>
            </button>
            <span class="text-xs font-semibold tracking-wide text-green-700"></span>
          </div>
        

       



       
      </nav>


      <nav class="mt-auto   ml-0   cursor-pointer pl-0 font-medium    px-0 space-y-1 ">
    
        <button @click="$router.push('/logout')"
          class="flex items-center ml-0 gap-2 px-4 py-2   text-white rounded-lg  bg-red-900 hover:bg-violet-900 transition">

          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 2v10m6.364-6.364a9 9 0 11-12.728 0" />
        </svg> 
        </button>


       <span class="text-xs font-semibold tracking-wide text-red-900">
        Salir
      </span>

      </nav>
   <!-- Submenú lateral (persiana) -->
    <transition
      enter-active-class="transition-all duration-300 ease-out"
      enter-from-class="opacity-0 -translate-x-4"
      enter-to-class="opacity-100 translate-x-0"
      leave-active-class="transition-all duration-200 ease-in"
      leave-from-class="opacity-100 translate-x-0"
      leave-to-class="opacity-0 -translate-x-4"
    >
      <div  
        v-if="subMenuAbierto"
         style="z-index: 1000;"
        class="hidden lg:block fixed left-[80px] top-0 bottom-0 w-64 z-30 border-l-4  "
      >
        <div class="flex flex-col h-full pt-5 ">
          <!-- Cabecera del submenú -->
          <div class="p-4   ">
            
          </div>

          <!-- Contenido del submenú -->
          <div class="flex-1 overflow-y-auto mt-3 p-1 space-y-2 font-mono    rounded-lg border border-violet-400  bg-violet-600 ">
              <div class="p-2 text-white text-lg">Año {{ this.$store.state.auth.userLogin.año  }}</div>
            
            <button 
              v-for="opcion in opcionesSubMenu" 
              :key="opcion.id"
              @click="seleccionarOpcion(opcion)"
              class="w-full text-left px-4 py-3 rounded-lg bg-violet-50 transition border border-gray-100 border-green-200 flex items-center gap-3"
            >
              <span class="text-lg" style="font-size:3rem">{{ opcion.icono }}</span>
              <div>
                <p class="text-sm font-medium text-gray-700">{{ opcion.nombre }}</p>
                <p class="text-xs text-gray-400">{{ opcion.descripcion }}</p>
              </div>
            </button>
          </div>

          <!-- Pie del submenú -->
          <div class="p-3 border-t border-gray-200 bg-gray-50">
     
          </div>
        </div>
      </div>
    </transition>

       <!-- Submenú lateral (persiana) -->
    <transition
      enter-active-class="transition-all duration-300 ease-out"
      enter-from-class="opacity-0 -translate-x-4"
      enter-to-class="opacity-100 translate-x-0"
      leave-active-class="transition-all duration-200 ease-in"
      leave-from-class="opacity-100 translate-x-0"
      leave-to-class="opacity-0 -translate-x-4"
    >
      <div  
        v-if="subMenuBorrAbierto"
         style="z-index: 1000;"
        class="hidden lg:block fixed left-[80px] top-0 bottom-0 w-64 z-30 border-l-4  "
      >
        <div class="flex flex-col h-full pt-5">
          <!-- Cabecera del submenú -->
          <div class="p-4   ">
            
          </div>

          <!-- Contenido del submenú -->
          <div class="flex-1 overflow-y-auto mt-3 p-1 space-y-2 font-mono       rounded-lg border border-green-400  bg-green-700  ">
              <div class="p-2  text-lg  text-white ">Año {{ aa_borrador }}</div>
            
            <button 
              v-for="opcion in opcionesSubMenuBorr" 
              :key="opcion.id"
              @click="seleccionarOpcionBorr(opcion)"
              class="w-full text-left px-4 py-3 rounded-lg bg-green-50 transition border border-gray-100 border-green-200 flex items-center gap-3"
            >
              <span class="text-lg"  style="font-size:3rem">{{ opcion.icono }}</span>
              <div>
                <p class="text-sm font-medium text-gray-700">{{ opcion.nombre }}</p>
                <p class="text-xs text-gray-400">{{ opcion.descripcion }}</p>
              </div>
            </button>
          </div>

          <!-- Pie del submenú -->
          <div class="p-3 border-t border-gray-200 bg-gray-50">
     
          </div>
        </div>
      </div>
    </transition>


    </div>
 
    <!-- OVERLAY - Este es el que cierra el menú -->
    <div 
      v-if="subMenuBorrAbierto"
      class="fixed inset-0  "
      style="z-index: 998;"
      @click="toggleSubMenuBorr"
    ></div>
    <!-- OVERLAY - Este es el que cierra el menú -->
    <div 
      v-if="subMenuAbierto"
      class="fixed inset-0  "
      style="z-index: 998;"
      @click="toggleSubMenuBorr" 
    ></div>


  </div>

</template>


<script>
import axios from "axios";
import { HomeIcon } from "@heroicons/vue/outline";

import { mapActions } from "vuex";
import {
  //BellIcon,

  LibraryIcon,
  UserGroupIcon,

  MapIcon
} from "@heroicons/vue/outline";
export default {
  name: "SideBarDesktopCliente",
  emits: [
    "chgFaenaCentros",
    "chgIdPantalla",
    "chgIdPantalla2",
    "handleDropFaena",
    "loadModalUsuarios",
    "loadModalServiceUnavailable"],
  data() {
    return {
      aa_borrador: this.$store.state.auth.userLogin.año_borrador,

      seleccion: {
        historial: 0,
        live: 0,
        resumen: false
      },
      adminNavigation: [
        { name: "Usuarios", click: () => this.showModalUsuario(), icon: UserGroupIcon },

      ],
      
      subMenuBorrAbierto: false,
      opcionesSubMenuBorr: [
              {
          id: 2,
          nombre: 'Presupuestos',
          descripcion: 'Presupuestos   para ' + ' '+ this.$store.state.auth.userLogin.año_borrador ,
          icono: '💰',
          accion: 'presupuestos_borr'
        },

        {
          id: 1,
          nombre: 'Ingreso de presupuestos',
          descripcion: 'Ingresar presupuestos por centro y cuentas '+ this.$store.state.auth.userLogin.año_borrador ,
          icono: '👩🏻‍💻',
          accion: 'solicitudes_borr'
        },
  
        {
          id: 3,
          nombre: 'Subir CSV',
          descripcion: 'Subir planilla en formato csv '+ this.$store.state.auth.userLogin.año_borrador ,
          icono: '🚀',
          accion: 'upload_borr'
        },
         {
          id: 4,
          nombre: 'Reporteria',
          descripcion: 'Reportes  para ' + ' '+ this.$store.state.auth.userLogin.año_borrador ,
          icono: '📊',
          accion: 'reporteria_borr'
        },
       
      ],

      
      subMenuAbierto: false,
      opcionesSubMenu: [
    
        {
          id: 1,
          nombre: 'Presupuestos',
          descripcion: 'Presupuestos año' + ' '+ this.$store.state.auth.userLogin.año ,
          icono: '💰',
          accion: 'presupuestos'
        },
         {
          id: 2,
          nombre: 'Reporteria',
          descripcion: 'Reportes & Ejecución presupuestaria año ' + ' '+ this.$store.state.auth.userLogin.año ,
          icono: '📊',
          accion: 'reporteria'
        },
       
      ],
      opcionesAdmin:[
         {
          id: 3,
          nombre: 'Gastos',
          descripcion: 'Subir planilla de gastos',
          icono: '💸',
          accion: 'gastos'
        },
         {
          id: 4,
          nombre: 'Descarga',
          descripcion: 'Descargar datos',
          icono: '📥',
          accion: 'descarga'
        },
          {
          id: 4,
          nombre: 'Historial gastos',
          descripcion: 'Historial upload planilla gastos',
          icono: '📋',
          accion: 'historial'
        } 
      ],
       opcionesAdminBorr:[
          
         {
          id: 4,
          nombre: 'Descarga',
          descripcion: 'Descargar datos',
          icono: '📥',
          accion: 'descarga_borr'
        },
         
      ]
    }
    
  },
  props: {
    navigation: {
      type: Object,
    },
    secondaryNavigation: {
      type: Object,
    },

    faenas: {
      type: Array,
    },
  },
  watch: {

  },
  components() {
    HomeIcon,
      LibraryIcon,
      UserGroupIcon,

      MapIcon
  },
  methods: {
    ...mapActions("draggdropp", ["draggableCreate", " setIdCurrentDrag"]),
    async showModalUsuario() {
      let cod = await this.chkPermisos();
      //console.log( 'cod', cod );
      if (cod == 401) {
        this.$emit("loadModalErrorAcceso", true);
      } else {
        if (cod == 200) {
          this.$emit("loadModalUsuarios", true);
        } else {

          this.$emit("loadModalServiceUnavailable", true);
        }
      }
    },
    async chkPermisos() {
      try {
        const apiKey = this.$store.state.login.tokenLogin;

        const data = {};
        const url = "/api/admin/getUsers";
        const resp = await axios.post(url, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${apiKey}`,
          },
        });
        if (resp.status === 200) {


          return resp.data.status;


        }
        return 0;

      } catch (err) {
        //console.log(err.response) ;         
      }
    },
    showModalConfiguracion() {
      //console.log('configuracion');
    },

    ExitCodAccion(id) {
      // //console.log("chgIdPantalla2 ", 1);
      this.seleccion.historial = 0;
      this.seleccion.live = 0;
      this.seleccion.resumen = true;
      this.$emit("chgIdPantalla", { id: id });
    },
  toggleSubMenu() {
    this.subMenuBorrAbierto=false
      this.subMenuAbierto = !this.subMenuAbierto
    },
  toggleSubMenuBorr() {
    this.subMenuAbierto=false
      this.subMenuBorrAbierto = !this.subMenuBorrAbierto
    },
    open_sub_menu() {
      this.subMenuBorrAbierto = true
    },
    seleccionarOpcion (opcion) {
    
      switch(opcion.accion) {
        case 'presupuestos':
            this.ExitCodAccion(2)
          break
        case 'reporteria':
          this.ExitCodAccion(8)
          break
        case 'gastos':
          this.ExitCodAccion(6)
          break
        case 'descarga': 
          this.ExitCodAccion(1)
          break
         case 'historial': 
          this.ExitCodAccion(7)
          break
      }
      // Cerrar submenú después de seleccionar
      this.subMenuAbierto = false
    },
    seleccionarOpcionBorr(opcion) {
      console.log('Opción seleccionada:', opcion)
      // Ejecutar acción según la opción
      switch(opcion.accion) {
        case 'solicitudes_borr':
            this.ExitCodAccion(3)
          break
        case 'ver':
          // Lógica para ver presupuestos
          break
        case 'upload_borr':
          this.ExitCodAccion(10)
          break
        case 'presupuestos_borr': 
          this.ExitCodAccion(12)
          break
         case 'reporteria_borr': 
          this.ExitCodAccion(11)
          break
        case 'descarga_borr': 
          this.ExitCodAccion(13)
        break
        }
      // Cerrar submenú después de seleccionar
      this.subMenuBorrAbierto = false
    }
  

  },
  mounted() {
    this.seleccion.resumen = true;

  if (this.$store.state.auth.userLogin.modifica_presupuestos){
    this.opcionesSubMenu.push(this.opcionesAdmin[0])
    this.opcionesSubMenu.push(this.opcionesAdmin[1])
    this.opcionesSubMenu.push(this.opcionesAdmin[2])
    
  }
  if (this.$store.state.auth.userLogin.modifica_presupuestos){
    this.opcionesSubMenuBorr.push(this.opcionesAdminBorr[0])
  
  }

  }
};
</script>
<style scoped>
/* Asegurar que el submenú esté por encima de todo */
.submenu-overlay {
  z-index: 99999 !important;
  position: fixed !important;
}

/* Forzar z-index en el submenú */
.submenu-panel {
  z-index: 99999 !important;
  position: fixed !important;
}

/* Asegurar que el overlay esté justo debajo */
.overlay-backdrop {
  z-index: 9998 !important;
}
</style>